export const env_domain =
  import.meta.env.env_domain || 'https://backend.staging.agromon.ru';
export const sat_domain =
  import.meta.env.sat_domain || 'https://satreceiver.app.agromon.ru';
export const geoprocessor_domain =
  import.meta.env.geoprocessor_domain ||
  'https://geoprocessor.staging.agromon.ru';
export const soilreceiver_domain =
  import.meta.env.soilreceiver_domain ||
  'https://soilreceiver.staging.agromon.ru';
export const env_type = import.meta.env.env_type || 'staging';
export const env_bayer = import.meta.env.env_bayer;
export const env_externalservices =
  import.meta.env.env_externalservices || env_bayer === 'true'
    ? 'false'
    : 'true';
export const PUBLIC_URL = import.meta.env.PUBLIC_URL
  ? `${import.meta.env.PUBLIC_URL}`
  : '';
export const env_commit = import.meta.env.env_commit;
export const NODE_ENV =
  import.meta.env.MODE === 'test'
    ? 'test'
    : import.meta.env.PROD
    ? 'production'
    : 'development';
// Use mocked responses
export const env_mock = import.meta.env.env_mock || false;
export const rosreestr_domain = 'https://nspd.agromon.ru';
